(function($) {

    $.fn.msxicheckall = function(options){
        // build main options before element iteration
        var opts = $.extend({}, $.fn.msxicheckall.defaults, options);

        return this.each(function(){
            var $this = $(this);
            var data = $(this).metadata();
            if (data && data.targetBoxes) {
                var isCheckbox = this.tagName.toLowerCase() == 'input';
                var $root;

                if(data.isTargetRelative) {
                    $root = $this;
                }
                if($this.parents('.ui-dialog').size() > 0) {
                    $root = $this.parents('.ui-dialog');
                }
                else {
                    $root = $(document);
                }

                var checkboxes = $root.find(data.targetBoxes).filter(':enabled');
                if (checkboxes.length > 0)
                {
                    // If "check all" control is a checkbox, set its initial state based on state of the checkboxes -
                    // basically it's checked if all the checkboxes are checked and not-checked otherwise.
                    var AllChecked = checkboxes.not(':checked').length == 0;
                    if(isCheckbox)
                    {
                        if(AllChecked)
                        {
                            $this.prop('checked', true);
                        }
                    }
                    else
                    {
                        $this.trigger("checked", AllChecked);
                    }
                    // add the click handler...
                    $this.click(function()
                                {
                                    var check;
                                    if(isCheckbox)
                                    {
                                        check = $(this).is(':checked'); // check all if toggling control is a checkbox and it has just been checked
                                    }
                                    else
                                    {
                                        check = checkboxes.not(':checked').length > 0; // otherwise check all if there are any not checked
                                    }

                                    // do the check / un-check all
                                    if(check)
                                    {
                                        checkboxes.not(':checked').prop('checked', true).trigger('change');
                                    }
                                    else
                                    {
                                        checkboxes.filter(':checked').prop('checked', false).trigger('change');
                                    }
                                    // return true for a checkbox so it checks, but false for a link so it doesn't navigate anywhere
                                    return isCheckbox;
                                });

                        // keep check-all state up-to-date as checkboxes are checked/unchecked
                        checkboxes.change(function() {
                            var check = $(this).is(':checked');
                            if(!check)
                            {
                                if(isCheckbox) {
                                    $this.prop('checked', false);
                                }
                                else {
                                    $this.trigger("checked", false);
                                }
                            }
                            else
                            {
                                var allChecked = checkboxes.not(':checked').length == 0;
                                if(allChecked)
                                {
                                    if(isCheckbox)
                                    {
                                        $this.prop('checked', true);
                                    }
                                    else
                                    {
                                        $this.trigger("checked", true);
                                    }
                                }
                            }
                        });
                }
            }
        });
    };

    //
    // plugin defaults
    //
    $.fn.msxicheckall.defaults = {
    };

    // To be run on any form-checkboxes div that has the addCheckAll class, and it removes that class when done.
    // Puts in a check-all control appropriate to the form style - in a horizontal form it's a checkbox div with a link in it,
    // whereas in a vertical form it's a checkbox on the line with the field label.
    $.fn.msxicheckall_addcheckall = function(){
        return this.each(function(){
            var $this = $(this);
            if($this.find('input:checkbox').size()>1) {
                var parentForm = $this.closest(".form");
                var verticalForm = parentForm.length > 0 && parentForm.hasClass('orientation-vertical');
                var checkAllClass = "checkAll {isTargetRelative: false, targetBoxes: '#" + $this.attr('id') + " .form-checkbox :checkbox:not(.checkAll)'}";
                if (verticalForm) {
                    var $formRow = $this.parent();
                    if ($formRow.find('.checkAll').size()==0) {
                        var checkAllCheckbox = $('<input type="checkbox"/>').attr('class', checkAllClass);
                        $formRow.prepend(checkAllCheckbox);
                    }
                }
                else
                {
                    var link = $('<a href="#"/>').attr('class', checkAllClass);
                    $(link).text(translate("Check / Un-Check All"));
                    $(link).bind('checked', function(e, checked){
                        if(!checked)
                        {
                            $(this).text(translate("Check All"));
                        }
                        else
                        {
                            $(this).text(translate("Un-Check All"));
                        }
                    });
                    var divCheckAll = $('<div class="form-checkbox"/>').prepend(link);
                    $this.prepend(divCheckAll);
                }
            }
        });
    };

})(jQuery);
